var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { IconSearch } from '@hawkins/icons/lib/iconSearch';
import { Input } from '../../../input';
import { useDebouncedSearch } from '../hooks/useDebouncedSearch';
var displayName = 'DropdownListSearchInput';
/**
 * Default component for the search input inside the dropdown list
 * @param param
 * @returns
 */
export function DropdownListSearchInput(props) {
    var ariaDescribedby = props.ariaDescribedby, ariaOwns = props.ariaOwns, className = props.className, debounceTime = props.debounceTime, disabled = props.disabled, id = props.id, inputRef = props.inputRef, name = props.name, onInputChange = props.onInputChange, onKeyDown = props.onKeyDown, query = props.query, searchInputClasses = props.searchInputClasses, searchInputProps = props.searchInputProps, searchPlaceholderLabel = props.searchPlaceholderLabel, translate = props.translate;
    var computedQueryValue = (query || (searchInputProps === null || searchInputProps === void 0 ? void 0 : searchInputProps.value) || '');
    var _a = useDebouncedSearch(computedQueryValue, debounceTime, onInputChange), searchQuery = _a.searchQuery, handleQueryChange = _a.handleQueryChange;
    useEffect(function () {
        setTimeout(function () {
            var _a, _b;
            (_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('input')) === null || _b === void 0 ? void 0 : _b.focus();
        }, 0);
    }, [inputRef]);
    return (_jsx(Input, __assign({ "aria-activedescendant": "", "aria-autocomplete": "both", "aria-describedby": ariaDescribedby, "aria-owns": ariaOwns, autoComplete: "off", classes: searchInputClasses, className: className, disabled: disabled, tabIndex: 0, startAdornment: _jsx(IconSearch, {}), fullWidth: true, id: "search-input-".concat(id), name: name, onChange: handleQueryChange, onKeyDown: onKeyDown, placeholder: searchPlaceholderLabel || (translate ? translate('dropdown.input.search.placeholder') : undefined), ref: inputRef, value: searchQuery, onFocus: function (e) {
            e.preventDefault();
            e.stopPropagation();
        } }, searchInputProps)));
}
DropdownListSearchInput.displayName = displayName;
